export const CleanHeatPartnersLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
      <path
        fill="#00988a"
        strokeWidth={0}
        d="M9.11,37.7h-.02v-17h0v-9.96h0c0-.34.19-4.95,4.98-4.95h9.14v-3.31c0-.85.15-1.55.39-2.14C17.4,1.32,4.41,5.41,4.41,22.52v22.48h5.22c-.31-.63-.51-1.42-.51-2.41v-4.89Z"
      />
      <path
        fill="#00988a"
        d="M32.68.03c.32.64.53,1.44.53,2.45v4.89h.02v17h0v9.96h0c0,.34-.19,4.95-4.98,4.95h-9.15s0,3.31,0,3.31c0,.84-.15,1.54-.38,2.12,6.16-.94,19.34-4.96,19.34-22.2V.03h-5.38Z"
      />
      <path
        strokeWidth={0}
        fill="#00988a"
        d="M16.62,42.58v-4.97h0v-7.99h0v-13.61l-1.53,1.86-1.83-1.5,4.52-5.48,4.73,5.46-1.79,1.55-1.62-1.87v4.73h0v16.04h9.14s2.49-.02,2.49-2.49h0v-9.94h1.46l-1.46-.02V2.49s-.02-2.17-2.04-2.45h-.95c-2.01.29-2.03,2.45-2.03,2.45v4.97h0v21.6s1.53-1.86,1.53-1.86l1.83,1.5-4.52,5.48-4.73-5.46,1.79-1.55,1.62,1.87v-4.73h0V8.28h-9.14s-2.49.02-2.49,2.49h0v9.94h-1.46l1.46.02v21.86s.02,2.04,1.87,2.42h1.28c1.85-.38,1.87-2.42,1.87-2.42Z"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="30.73 24.37 30.73 34.3 33.23 34.3 33.23 24.38 32.18 24.37 30.73 24.37"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M33.23,34.33v-.02s0,0,0,.02h0Z"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="23.22 24.31 23.22 29.05 24.5 30.52 25.71 29.06 25.71 15.45 25.71 24.35 23.22 24.31"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="23.22 32.36 23.22 29.05 21.6 27.18 19.82 28.73 24.55 34.19 29.07 28.71 27.24 27.2 25.71 29.06 25.71 32.36 23.22 32.36"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="23.22 29.05 23.22 32.36 25.71 32.36 25.71 29.06 24.5 30.52 23.22 29.05"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="30.73 7.46 30.73 24.35 32.18 24.37 33.23 24.37 33.23 7.36 33.21 7.36 33.21 7.46 30.73 7.46"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="33.23 24.38 33.23 24.37 32.18 24.37 33.23 24.38"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="25.09 8.28 23.22 8.28 23.22 24.31 23.22 24.31 23.22 15.45 25.71 15.45 25.71 7.46 25.09 7.46 25.09 8.28"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="23.22 24.31 25.71 24.35 25.71 15.45 23.22 15.45 23.22 24.31"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M23.61.34c1.95-.31,3.24-.31,3.24-.31h.89c.14-.02.29-.03.45-.03"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M23.22,5.79h1.87v1.54h.61v.13h0V2.49s.02-2.17,2.03-2.45h-.89s-1.29,0-3.24.31c-.24.58-.39,1.29-.39,2.14v3.31Z"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="25.09"
        y="7.33"
        width=".61"
        height=".13"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M28.24,0c.16,0,.31.01.45.03h3.99"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M30.73,2.49v4.88h2.49V2.48c0-1.01-.2-1.8-.53-2.45h-3.99c2.02.28,2.04,2.45,2.04,2.45Z"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="30.73"
        y="7.36"
        width="2.49"
        height=".09"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M30.73,34.3h0c0,2.47-2.49,2.49-2.49,2.49h-9.14v2.49h9.15c4.79,0,4.97-4.6,4.98-4.95l-2.5-.02h0Z"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M30.73,34.31l2.5.02s0-.02,0-.02h-2.5Z"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="9.1 20.68 10.14 20.7 11.6 20.7 11.6 10.76 9.1 10.76 9.1 20.68"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M9.1,10.74v.02s0,0,0-.02h0Z"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="19.11 20.75 19.11 16.02 17.82 14.54 16.62 16 16.62 29.62 16.62 29.62 16.62 20.72 19.11 20.75"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="19.11 12.71 19.11 16.02 20.72 17.89 22.51 16.34 17.78 10.88 13.26 16.36 15.09 17.86 16.62 16 16.62 12.71 19.11 12.71"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="19.11 16.02 19.11 12.71 16.62 12.71 16.62 16 17.82 14.54 19.11 16.02"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="9.1 37.7 9.11 37.7 9.11 37.61 11.6 37.61 11.6 20.72 10.14 20.7 9.1 20.7 9.1 37.7"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="9.1 20.7 10.14 20.7 9.1 20.68 9.1 20.7"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="17.23 36.79 19.11 36.79 19.11 29.62 16.62 29.62 16.62 37.61 17.23 37.61 17.23 36.79"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="19.11 20.75 19.11 20.75 19.11 29.62 19.11 20.75"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="17.23"
        y="36.79"
        width="1.87"
        height=".82"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="19.11 20.75 16.62 20.72 16.62 29.62 19.11 29.62 19.11 20.75"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M19.11,39.28h-1.87v-1.54h-.61v-.13h0v4.97s-.02,2.04-1.87,2.42h.87s1.22,0,3.1-.29c.24-.58.38-1.28.38-2.12v-3.31Z"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="17.23"
        y="37.74"
        width="1.87"
        height="1.54"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="16.62"
        y="37.61"
        width=".61"
        height=".13"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="17.23"
        y="37.61"
        width="1.87"
        height=".13"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M11.6,42.58v-4.88h-2.49v4.89c0,.99.2,1.78.51,2.41h3.85c-1.85-.38-1.87-2.42-1.87-2.42Z"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="9.11"
        y="37.61"
        width="2.49"
        height=".09"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M23.22,7.33v-1.54h-9.14c-4.79,0-4.97,4.6-4.98,4.95l2.5.02h0s0,0,0,0c0-2.47,2.49-2.49,2.49-2.49h9.14v-.95h0Z"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        points="25.09 7.46 23.22 7.46 23.22 7.33 23.22 7.33 23.22 8.28 25.09 8.28 25.09 7.46"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="23.22"
        y="5.79"
        width="1.87"
        height="1.54"
      />
      <rect
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        x="23.22"
        y="7.33"
        width="1.87"
        height=".13"
      />
      <path
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M9.1,10.74s0,.02,0,.02h2.5s-2.5-.02-2.5-.02Z"
      />
    </svg>
  );
};
